<template>
  <el-collapse-transition>
    <div class="bid" :data-id="bid.id">
      <div class="bid__brief">
        <div class="bid__type">
          {{ getTypeCode }}
        </div>
        <div class="bid__direction-info">
          <div class="info__item">
            {{ formattedNumberInteger(bid.distance) }} км
          </div>
          <div class="info__item">
            {{ formattedNumberInteger(bid.weight) }} т.
          </div>
        </div>
      </div>
      <div class="bid__main">
        <div class="bid__main-img">
          <div class="arrow" />
          <div class="dots" />
          <div class="circle" />
        </div>
        <div class="bid__direction">
          <div class="bid__direction-load">{{ loadLocationFilter(bid) }}</div>
          <div class="bid__direction-region bid__smalltext">
            {{ bid.load_point.split(',')[0] }}
          </div>
          <div class="bid__direction-unload">{{ getStevedore() }}</div>
          <div class="bid__direction-region bid__smalltext">
            {{ bid.unload_point.split(',')[1] }}
          </div>
        </div>
      </div>
      <day-info :days="days" :choosed="!!day" />
      <div class="bid__info">
        <div class="bid__smalltext">{{ getInfo() }}</div>
        <!--        <div class="bid__smalltext">{{ bid.comment }}</div>-->
        <div v-if="bid.private_comment && isApproved()" class="bid__smalltext">
          {{ bid.private_comment }}
        </div>
      </div>
    </div>
  </el-collapse-transition>
</template>

<script>
import { formattedNumberInteger, roundUp } from '@/helpers/functions'
import { mapGetters } from 'vuex'
import { typeCodes } from '@/datas/consts'
import DayInfo from './components/DayInfo'
import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'BidMobileBrief',
  components: {
    DayInfo,
  },
  mixins: [shippingMixin],
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    freight: {
      type: String,
      default: '',
    },
    day: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formattedNumberInteger,
    }
  },
  computed: {
    ...mapGetters({ getTypeView: 'bids/getTypeView' }),
    getTypeCode() {
      const type = typeCodes.find(t => t.label === this.bid.type_code)

      return type ? type.full || type.title : ''
    },
    days() {
      const days = this.day ? [this.day] : [...this.bid.future_days]
      const user = this.isExpOrAdm ? 'bidder' : 'driver'
      let type = this.bid.type_code === 'harvest' ? 'field' : 'storage'
      const field = `price_from_${type}_${user}`
      const field2 = `price_from_field_${user}`

      return days.reduce((d, x) => {
        const { [field]: price, [field2]: price2, load_date } = x
        const priceFormatted = roundUp(price, 1000)
        const priceText = `${priceFormatted} ₽/кг`
        const twoPrices = this.bid.type_code === 'harvest_or_delivery'
        let priceType = twoPrices ? ' Перевозка: ' : ''
        let priceText2 = twoPrices ? `${roundUp(price2, 1000)} ₽/кг` : ''
        let priceType2 = twoPrices ? ' Уборка: ' : ''

        if (d[priceFormatted]) {
          d[priceFormatted].dates.push(load_date)
        } else {
          d[priceFormatted] = {
            dates: [load_date],
            priceText,
            priceType,
            priceText2,
            priceType2,
          }
        }

        return d
      }, {})
    },
    entries() {
      return this.bid.entries || []
    },
    isExpOrAdm() {
      return this.isExp || this.isAdminOrCeoRole
    },
    isExp() {
      return this.userInfo.user_type === 2
    },
  },
  mounted() {
    this.$nextTick(() => this.$emit('ready'))
  },
  methods: {
    emitNext(bid) {
      this.$emit('next', bid)
    },
    isApproved() {
      return this.entries.find(e => Number(e.master_approve_status) === 1)
    },
    getStevedore() {
      const { organization } = this.bid
      const org =
        organization && organization.short_name
          ? ` на ${organization.short_name}`
          : ''

      return this.findStevedore(this.bid) + org
    },
    getInfo() {
      const { is_trawl, lifting_capacity, load_type_name } = this.bid
      let res = this.freight

      res += is_trawl ? ', грузим траллы' : ''

      res += load_type_name
        ? `, способ погрузки: ${
            load_type_name.charAt(0).toLowerCase() + load_type_name.slice(1)
          }`
        : ''

      if (lifting_capacity) {
        const text = this.getWeightText(lifting_capacity)

        res += `, весы на погрузке ${text}`
      }

      return res
    },
    getWeightText(count) {
      let text = ' тонн'
      const res10 = count % 10
      const res100 = count % 100

      if (res10 === 1 && res100 !== 11) {
        text = ' тонна'
      }
      if ([2, 3, 4].includes(res10) && ![12, 13, 14].includes(res100)) {
        text = ' тонны'
      }

      return count + text
    },
  },
}
</script>

<style lang="sass" scoped>
.bid__main-img
  display: flex
  flex-direction: column
  align-items: center
  height: 9.6rem
  margin-top: .5rem

  .arrow
    width: 1.6rem
    height: 1.6rem
    margin-bottom: .2rem
    background: url('~@/assets/img/new-bid-arrow.svg')
    background-size: cover

  .dots
    width: .2rem
    height: 3.3rem
    background: url('~@/assets/img/new-dots.svg') no-repeat
    background-size: cover
  .circle
    width: 1.6rem
    height: 1.6rem
    margin-top: -.3rem
    background: url('~@/assets/img/new-circle.svg')
    background-size: cover

.bid__info
  margin-top: 1.6rem
  &-title
    margin: .8rem 0 .4rem
    font-size: 1.4rem
    font-weight: 700
    line-height: 1.8rem

.bid .bid__brief
  display: flex
  justify-content: space-between
  align-items: center

  .bid__direction-info
    margin: 0 0 1.2rem

    .info__item
      margin-right: 0
      margin-left: 0.8rem

.bid .bid__main .bid__direction
  margin-bottom: 0

.bid .bid__main .bid__direction .bid__direction-region
  margin-bottom: 1.5rem
</style>
